import React, {useEffect, useState} from "react";
import {Form, Select} from "antd";
import DraggableEditModal from "./DraggableEditModal";

const ClassStylesEditor = props => {
    const {display = false, editableClasses = {}, className, styles = {}, updateEditClass, updateStylesCallback} = props;
    const [BodyComponent, setBodyComponent] = useState(null);

    useEffect(() => {
        const componentData = editableClasses[className];
        if (componentData) {
            let params = {
                updateStylesCallback: updateStylesCallback
            }
            if (componentData.variant) params.variant = componentData.variant;
            setBodyComponent(() => (props) => {
                const Component = componentData.component;
                return <Component {...params} {...props} />;
            });
        } else {
            setBodyComponent(null);
        }
    }, [className]);

    if (!display) return null;

    return (
        <DraggableEditModal
            open={display}
            onClose={() => updateEditClass(null)}
        >
            <div style={{ width: 240 }}>
                {Object.keys(editableClasses).length > 0 && (
                    <Select
                        className="margin-b--m"
                        onChange={updateEditClass}
                        value={className}
                        virtual={false}
                        showSearch={false}
                        style={{width: '100%'}}
                    >
                        {Object.entries(editableClasses).map(([className, {component, variant}]) => (
                            <Select.Option key={className} value={className}>
                                {className}
                            </Select.Option>
                        ))}
                    </Select>
                )}
                {BodyComponent && (
                    <BodyComponent styles={styles} />
                )}
            </div>
        </DraggableEditModal>
    )
}

export default ClassStylesEditor;